import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-ach-authorization-dialog',
    templateUrl: './ach-authorization-dialog.component.html',
    styleUrls: ['./ach-authorization-dialog.component.scss'],
    standalone: false
})
export class AchAuthorizationDialogComponent {
  achAgreementForm: FormGroup;
  constructor(
    readonly fb: FormBuilder,
    readonly dialogRef: MatDialogRef<AchAuthorizationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ipAddress: string } // Pass IP address as data
  ) {
    this.achAgreementForm = this.fb.group({
      authorizer_first_name: ['', Validators.required],
      authorizer_last_name: ['', Validators.required],
      agreement_terms: [
        'By clicking the button below, I affirm that I have proper authority and authorize Allegion to charge this bank account owned by Jane Doe (or as specified in the form below) for the recurring subscription amount. This authorization will continue on a periodic basis, as outlined in the subscription terms, until this subscription is canceled. If Jane Doe makes changes to this subscription that affect these terms, this agreement will remain in effect according to the updated terms. In the event that an incorrect amount is debited from this account, I authorize Allegion to credit this account in order to correct the situation. This payment authorization is valid and in compliance with NACHA regulations and will remain in effect unless I, or another authorized user, notify Allegion of its cancellation by contacting Support@allegion.com or 877.671.7011.',
        Validators.required,
      ],
      ip_address: [data.ipAddress, Validators.required], // Prepopulate IP address
    });
  }
  /* istanbul ignore next */
  onSubmit() {
    if (this.achAgreementForm.valid) {
      this.dialogRef.close(this.achAgreementForm.value); // Send form data back
    }
  }
  /* istanbul ignore next */
  onCancel() {
    this.dialogRef.close();
  }
}
